import { LIVE_CASE } from "../../../constants/constants";
import { tabAccessControl } from "../../../utils/utils";
import AccountSettings from "../../AccountSettings/AccountSettings";
import CallbackDashboard from "../../CallbackDashboard/CallbackDashboard";
import Callback from "../../CallbackTab/Callback";
import CallbackHistory from "../../CallbackTab/CallbackHistory/CallbackHistory";
import CallHistory from "../../CallTab/CallHistory/CallHistory";
import CallWebcase from "../../CallTab/CallWebcase";
import CaseComponent from "../../CasePage/CaseWebcase/CaseComponent";
import CaseHistoryComponent from "../../CasePage/CaseWebcase/CaseHistoryComponent";
import ChatWebcase from "../../ChatPage";
import ChatHistory from "../../ChatPage/History/ChatHistory";
import Supervisor from "../../Supervisor";
import Voicemail from "../../VoicemailTab/Voicemail";
import VoicemailHistory from "../../VoicemailTab/VoicemailHistory/VoicemailHistory";

export const caseTabs = [
  {
    id: 1,
    name: LIVE_CASE,
    children: <CaseComponent />,
  },
  {
    id: 2,
    name: "History",
    children: <CaseHistoryComponent />,
  },
];

export const callTabs = [
  {
    id: 1,
    name: "Call",
    children: <CallWebcase />,
    active: "true",
  },
  {
    id: 2,
    name: "History",
    children: <CallHistory />,
    active: "true",
  },
  {
    id: 3,
    name: "Monitoring",
    children: <Supervisor />,
    active: tabAccessControl("contact_monitor"),
  },
];

export const callbackTabs = [
  {
    id: 1,
    name: "Callback",
    children: <Callback />,
    active: "true",
  },
  {
    id: 2,
    name: "History",
    children: <CallbackHistory />,
    active: "true",
  },
  {
    id: 3,
    name: "Callback Dashboard",
    children: <CallbackDashboard />,
    active: tabAccessControl("callback_dashboard"),
  },
];

export const voicemailTabs = [
  {
    id: 1,
    name: "Voicemail",
    children: <Voicemail />,
    active: "true",
  },
  {
    id: 2,
    name: "History",
    children: <VoicemailHistory />,
    active: "true",
  },
];

export const settingsTabs = [
  {
    id: 1,
    name: "Account settings",
    children: <AccountSettings />,
    active: "true",
  },
];

export const chatTabs = [
  {
    id: 1,
    name: "Chats",
    children: <ChatWebcase />,
    active: "true",
  },
  {
    id: 2,
    name: "History",
    children: <ChatHistory />,
    active: "true",
  },
];
